import React from 'react';

const ServiceDescription = () => {
	return(
		<div className="service__description">
			<p className="service__service">Contamos con un staff de INGENIEROS CALIFICADOS, siendo posible apoyarlos en sus proyectos desde el Diseño, Montaje, hasta la operación y posteriormente el mantenimiento</p>
		</div>
	)
}
export default ServiceDescription;